module.exports = __webpack_public_path__ + "img/b824291.png";